import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/my_number_card.png")